import { signal } from '@preact/signals-react';

export type CommandPaletteCommand = {
  id: string;
  label: string;
  description?: string;
  keywords?: string[];
  run: () => void;
};

export const commandPaletteOpen = signal(false);
export const commandPaletteContext = signal<CommandPaletteCommand[]>([]);
const commandPaletteContextBySource = new Map<string, CommandPaletteCommand[]>();

function publishCommandPaletteContext() {
  commandPaletteContext.value = [...commandPaletteContextBySource.values()].flat();
}

export function setCommandPaletteContext(commands: CommandPaletteCommand[], source = 'default') {
  commandPaletteContextBySource.set(source, commands);
  publishCommandPaletteContext();
}

export function clearCommandPaletteContext(source = 'default') {
  commandPaletteContextBySource.delete(source);
  publishCommandPaletteContext();
}

export function isCommandPaletteShortcut(event: Pick<KeyboardEvent, 'ctrlKey' | 'metaKey' | 'shiftKey' | 'key'>) {
  return (event.ctrlKey || event.metaKey) && event.shiftKey && event.key.toLowerCase() === 'p';
}

export function isClearSiteDataShortcut(event: Pick<KeyboardEvent, 'altKey' | 'ctrlKey' | 'metaKey' | 'shiftKey' | 'key'>) {
  return (event.ctrlKey || event.metaKey) && event.shiftKey && event.altKey && event.key.toLowerCase() === 'l';
}
